import React, { useMemo, useState } from 'react';
import I18n from '@utils/i18n';
import { Table, TableSize } from '@ui/molecules/Table/Table';
import { TechnicianCell } from './cells/TechnicianCell';
import { ScheduledDateCell } from './cells/ScheduledDateCell';
import { ActionsCell } from './cells/ActionsCell';
import './VisitsTableStyles.scss';
function compareStrings(a, b) {
    if (a === b)
        return 0;
    if (a === null)
        return 1;
    if (b === null)
        return -1;
    return a.localeCompare(b);
}
function compareVisits(a, b, key) {
    switch (key) {
        case 'tech':
            return compareStrings(a.techName, b.techName);
        case 'scheduledTime':
        case 'scheduledDate':
            return compareStrings(a.scheduledDateIso, b.scheduledDateIso);
        case 'duration':
            return compareStrings(a.durationDisplay, b.durationDisplay);
        default:
            return 0;
    }
}
function VisitsTable({ visits, subcontractorsEnabled }) {
    const [sortBy, setSortBy] = useState('scheduledDate');
    const [sortDirection, setSortDirection] = useState('asc');
    const sortedVisits = useMemo(() => {
        const copy = [...visits];
        copy.sort((a, b) => {
            const result = compareVisits(a, b, sortBy);
            return sortDirection === 'asc' ? result : -result;
        });
        return copy;
    }, [visits, sortBy, sortDirection]);
    const handleSort = (dataKey, direction) => {
        setSortBy(dataKey);
        setSortDirection(direction);
    };
    const columns = useMemo(() => [
        {
            dataKey: 'scheduledDate',
            label: I18n.t('inspections.show.visits.scheduled_date'),
            columnType: 'primary',
            renderer: ScheduledDateCell
        },
        {
            dataKey: 'scheduledTime',
            label: I18n.t('inspections.show.visits.scheduled_time'),
            renderer: ({ item }) => React.createElement(React.Fragment, null, item.scheduledTimeDisplay)
        },
        {
            dataKey: 'tech',
            label: subcontractorsEnabled
                ? I18n.t('inspections.show.visits.technician_or_subcontractor')
                : I18n.t('inspections.show.visits.technician'),
            renderer: TechnicianCell
        },
        {
            dataKey: 'duration',
            label: I18n.t('inspections.show.visits.duration'),
            renderer: ({ item }) => React.createElement(React.Fragment, null, item.durationDisplay)
        },
        {
            dataKey: 'actions',
            label: '',
            width: '1px',
            align: 'right',
            columnType: 'last',
            renderer: ActionsCell
        }
    ], [subcontractorsEnabled]);
    return (React.createElement(Table, { className: "visits-table", data: sortedVisits, columns: columns, variant: "detail", size: TableSize.Full, sortable: true, sortableColumns: ['tech', 'scheduledDate', 'scheduledTime', 'duration'], sortBy: sortBy, sortDirection: sortDirection, onSort: handleSort, getItemId: (visit) => visit.id }));
}
export default VisitsTable;
